import { AxiosError, HttpStatusCode } from "axios";
import { IAxiosReturnFail } from "./interface";

/**
 * Processes an Axios error into a standard IAxiosReturn
 *
 * @param msg - The error message prefix to prepend to the error details
 * @param error - The Axios error object to process
 * @returns IAxiosReturn
 */
export const processAxiosError = (msg: string, error: unknown): IAxiosReturnFail => {
  // Base error
  let errorText = `${msg}, unknown error`;

  // Check for axios error
  switch ((error as AxiosError).response?.status) {
    case HttpStatusCode.TooManyRequests:
      errorText = `${msg}, ${
        ((error as AxiosError).response as { data?: { message: string } }).data?.message ??
        "The report you are trying to access is currently in use, please try again later."
      }`;
      break;

    case HttpStatusCode.Forbidden:
      errorText = `${msg}, ${
        ((error as AxiosError).response as { data?: { message: string } }).data?.message ??
        "access denied"
      }`;
      break;

    case HttpStatusCode.BadRequest:
      {
        const data = ((error as AxiosError).response as { data?: string | { message?: string } })
          .data;
        const message = typeof data === "string" ? data : data?.message;
        errorText = `${msg}${message ? `, ${message}` : ""}`;
      }
      break;
    case HttpStatusCode.InternalServerError:
      errorText = `${msg}, server error`;
      break;
    default:
      switch ((error as AxiosError).code) {
        case "ERR_NETWORK":
          errorText = `${msg}, network error`;
          break;

        case "ERR_CANCELED":
          errorText = `${msg}, request cancelled`;
          break;

        case "ERR_BAD_RESPONSE":
          errorText = `${msg}, server error`;
          break;

        case "ERR_BAD_REQUEST":
          {
            errorText = `${msg}`;
            const badRequestMessage =
              ((error as AxiosError).response as { data?: { message: string } }).data?.message ??
              "";
            if (badRequestMessage !== "") {
              errorText += `, ${badRequestMessage}`;
            }
          }
          break;
        default:
          if ((error as Error).message) {
            errorText = `${msg}, ${(error as Error).message}`;
          }
      }
      break;
  }
  return { success: false, errorText };
};
